import axios, { AxiosResponse, AxiosRequestConfig, AxiosInstance } from 'axios';

/**
 * Defining a type for the Axios Configuration
 *
 * @typedef {object} T Response model type for the custom service
 */
declare module 'axios' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface AxiosResponse<T> extends Promise<T> { }
};

/**
 * Handle request method
 *
 * @param {AxiosRequestConfig} config Axios request configuration
 */
const _handleRequest = async (config: AxiosRequestConfig) => {
  return config;
};

/**
 * Handle error method
 *
 * @param {Error} error Axios exception error
 */
const _handleError = (error: Error) => Promise.reject(error);

/**
 * Handle response method
 *
 * @param {AxiosResponse} data Data pulled from the response model
 */
const _handleResponse = ({ data }: AxiosResponse) => data;

/**
 * Create Service Instance
 * @description Allows a service to create an instance of Axios
 *
 * @param {string} baseURL Base url for the new axios instance
 */
export const createServiceInstance = (baseURL: string, token: string): AxiosInstance => {
  const config: AxiosRequestConfig = {
    baseURL: baseURL,
    headers: {
      Authorization: `Bearer ${token}`
    }
  };

  const instance = axios.create(config);

  instance.interceptors.request.use(
    _handleRequest,
    _handleError,
  );

  instance.interceptors.response.use(
    _handleResponse,
    _handleError,
  );

  return instance;
};

export const mockRequest = async <TResponse>(url: string, mockResponse: TResponse): Promise<AxiosResponse<TResponse>> => {
  // Wait for mock request to complete
  await new Promise(r => setTimeout(r, 1500));

  // console.warn('REQUEST IS MOCKED!', url);

  return mockResponse;
};
